import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import { useBox } from "../../Finanzas/Helper/useBox";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import HandymanIcon from "@mui/icons-material/Handyman";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import BuildIcon from "@mui/icons-material/Build";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import Swal from "sweetalert2";
import { GetKey } from "../../CreditoyCobranza/ReporteCobranza/Actions/GetContainer";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { TrendingDown } from "@mui/icons-material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingFlatIcon from "@mui/icons-material/Remove";
import { MensajeGarantiaModal } from "./Garantia/MensajeGarantiaModal";
import { GarantiasChart } from "./Garantia/GarantiasChart";
import { CotizacionesDashPosventa } from "./Cotizaciones/CotizacionesDashPosventa";
import FiltroDashboardPostventaPersiste from "./Modales/FiltroDashboardPostventaPersiste";
import MantenimientoPanelDashboard from "./Mantenimiento/MantenimientoPanelDashboard";
import GarantiasPanelDashboard from "./Mantenimiento/GarantiasPanelDashboard";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const DahsboardMainScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const [boxstate, setBoxState] = useBox();
  const [info, setInfo] = useState({});
  const [proyeccionServicio, setProyeccionServicio] = useState(0);
  const [margenServicio, setMargenServicio] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [proyeccionRefacciones, setProyeccionRefacciones] = useState(0);
  const [margenRefacciones, setMargenRefacciones] = useState(0);
  const [totalServicio, setTotalservicio] = useState(0);
  const [costoServicio, setCostoServicio] = useState(0);
  const [totalRefacciones, setTotalRefacciones] = useState(0);
  const [costoRefacciones, setCostoRefacciones] = useState(0);
  const [cotizaciones, setCotizaciones] = useState({});
  const [serviciosPendientes, setServiciosPendientes] = useState({});
  const [garantiasTempranas, setGarantiasTempranas] = useState({});
  const [garantiasTardias, setGarantiasTardias] = useState({});
  const [garantiasChecklist, setGarantiasChecklist] = useState({});
  const [openHelp, setOpenHelp] = useState(false);
  // const [vencimientoGarantiasTemprana, setVencimientoGarantiasTemprana] =
  //   useState();
  // const [vencimientoGarantiasTardia, setVencimientoGarantiasTardia] =
  //   useState();
  // const [vencimientoGarantiasChecklist, setVencimientoGarantiasChecklist] =
  //   useState();
  const [dataVencimientos, setDataVencimientos] = useState();
  const [selectedTipoGarantia, setSelectedTipoGarantia] = useState();
  const [filtroFecha, setFiltroFecha] = useState({
    ejercicio_inicio: 2026,
    ejercicio_fin: 2026,
    periodo_inicio: 1,
    periodo_fin: 1,
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const {
    sucursales,
    adr,
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    estatus,
    motivo,
    filtroSucursales,
    regresar,
  } = location.state || {};

  // console.log(location.state)

  const currentDate = new Date();
  const anioActual = currentDate.getFullYear(); // Año actual
  const mesActual = currentDate.getMonth() + 1; // Mes actual (0-11, por eso sumamos 1)

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    setFiltroFecha({
      ...filtroFecha,
      ejercicio_inicio: anioActual,
      ejercicio_fin: anioActual,
      periodo_inicio: mesActual,
      periodo_fin: mesActual,
    });

    if (regresar === true) {
      onIniciar(
        ejercicio_inicio || anioActual,
        ejercicio_fin || anioActual,
        periodo_inicio || mesActual,
        periodo_fin || mesActual,
        sucursales,
        adr,
      );
    } else {
      onExecute(anioActual, anioActual, mesActual, mesActual);
    }
  }, []);

  const onIniciar = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    filtroSucursales,
    filtroAdr,
  ) => {
    var sucursalesEnviar = filtroSucursales;
    var adrEnviar = filtroAdr;

    setFiltroFecha({
      ...filtroFecha,
      ejercicio_inicio: ejercicio_inicio,
      ejercicio_fin: ejercicio_fin,
      periodo_inicio: periodo_inicio,
      periodo_fin: periodo_fin,
    });

    var p_fin = "";
    if (
      filtroSucursales === undefined ||
      filtroSucursales === null ||
      filtroSucursales === ""
    ) {
      sucursalesEnviar = "0";
    }
    if (filtroAdr === undefined || filtroAdr === null || filtroAdr === "") {
      adrEnviar = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (
      Number(p_fin) < Number(periodo_inicio) &&
      Number(ejercicio_fin) < Number(ejercicio_inicio)
    ) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning",
      );
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/Dashboard?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&adr=${adrEnviar}&sucursal=${sucursalesEnviar}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          const totalProyeccionServicio = result.proyecciones.find(
            (item) => item.iddepartamento === 3,
          );
          const totalProyeccionRefacciones = result.proyecciones.find(
            (item) => item.iddepartamento === 2,
          );

          const totalServicio = result.servicio.find(
            (item) => item.concepto.toLowerCase() === "total servicio",
          );
          const totalRefacciones = result.refacciones.find(
            (item) => item.concepto.toLowerCase() === "total refacciones",
          );

          setProyeccionServicio(totalProyeccionServicio?.proyeccion || 0);
          setMargenServicio(totalProyeccionServicio?.margen || 0);
          setProyeccionRefacciones(totalProyeccionRefacciones?.proyeccion || 0);
          setMargenRefacciones(totalProyeccionRefacciones?.margen || 0);

          setTotalservicio(totalServicio?.total || 0);
          setCostoServicio(totalServicio?.margen || 0);
          setTotalRefacciones(totalRefacciones?.total || 0);
          setCostoRefacciones(totalRefacciones?.margen || 0);
          setCotizaciones(result.cotizaciones);
          setServiciosPendientes(result.servicios_pendientes);
          setGarantiasTempranas(result.power_venta_temprana);
          setGarantiasTardias(result.power_venta_tardia);
          setGarantiasChecklist(result.power_venta_checklist);
          // setVencimientoGarantiasTemprana(
          //   result.vencimiento_garantias_temprana
          // );
          // setVencimientoGarantiasTardia(result.vencimiento_garantias_tardia);
          // setVencimientoGarantiasChecklist(
          //   result.vencimiento_garantias_checklist
          // );
          setDataVencimientos(result.vencimiento_garantias_grafica);
          setInfo(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const onExecute = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
  ) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    setFiltroFecha({
      ...filtroFecha,
      ejercicio_inicio: ejercicio_inicio,
      ejercicio_fin: ejercicio_fin,
      periodo_inicio: periodo_inicio,
      periodo_fin: periodo_fin,
    });

    var p_fin = "";
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (
      Number(p_fin) < Number(periodo_inicio) &&
      Number(ejercicio_fin) < Number(ejercicio_inicio)
    ) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning",
      );
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/Dashboard?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&adr=${adr}&sucursal=${sucursales}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          // console.log(result)

          const totalProyeccionServicio = result.proyecciones.find(
            (item) => item.iddepartamento === 3,
          );
          const totalProyeccionRefacciones = result.proyecciones.find(
            (item) => item.iddepartamento === 2,
          );

          const totalServicio = result.servicio.find(
            (item) => item.concepto.toLowerCase() === "total servicio",
          );
          const totalRefacciones = result.refacciones.find(
            (item) => item.concepto.toLowerCase() === "total refacciones",
          );

          setProyeccionServicio(totalProyeccionServicio?.proyeccion || 0);
          setMargenServicio(totalProyeccionServicio?.margen || 0);
          setProyeccionRefacciones(totalProyeccionRefacciones?.proyeccion || 0);
          setMargenRefacciones(totalProyeccionRefacciones?.margen || 0);

          setTotalservicio(totalServicio?.total || 0);
          setCostoServicio(totalServicio?.margen || 0);
          setTotalRefacciones(totalRefacciones?.total || 0);
          setCostoRefacciones(totalRefacciones?.margen || 0);
          setCotizaciones(result.cotizaciones);
          setServiciosPendientes(result.servicios_pendientes);
          setGarantiasTempranas(result.power_venta_temprana);
          setGarantiasTardias(result.power_venta_tardia);
          setGarantiasChecklist(result.power_venta_checklist);
          // setVencimientoGarantiasTemprana(
          //   result.vencimiento_garantias_temprana
          // );
          // setVencimientoGarantiasTardia(result.vencimiento_garantias_tardia);
          // setVencimientoGarantiasChecklist(
          //   result.vencimiento_garantias_checklist
          // );
          setDataVencimientos(result.vencimiento_garantias_grafica);
          setInfo(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  // console.log(serviciosPendientes)

  const onGarantia = () => {
    history.push("/Postventa/Garantia");
  };
  const onConfiguracionGarantia = () => {
    history.push("/PostVenta/ConfigurarMontos");
  };
  const onMensajeGarantia = (tipo) => {
    setSelectedTipoGarantia(tipo);
    handleOpenModal();
  };
  const onCotizaciones = () => {
    history.push("/PostVenta/CotizacionesDashboard");
  };
  const onMantenimiento = (estatus, motivo) => {
    history.push("/Postventa/Mantenimiento", {
      sucursales: GetKey(boxstate.pv.sucursal, ["idsucursal"]),
      adr: GetKey(boxstate.pv.adr, ["idadr"]),
      ejercicio_inicio: filtroFecha.ejercicio_inicio,
      ejercicio_fin: filtroFecha.ejercicio_fin,
      periodo_inicio: filtroFecha.periodo_inicio,
      periodo_fin: filtroFecha.periodo_fin,
      estatus: estatus,
      motivo: motivo,
      filtroSucursales: boxstate.pv,
    });
  };
  const onContacto = () => {
    history.push("/Postventa/Contacto");
  };

  const onRegresar = () => {
    history.push("/Postventa/Main");
  };

  const renderIcon = (concepto) => {
    if (!concepto) return null;

    const conceptoLower = concepto.toLowerCase();

    if (conceptoLower === "total servicio") return null;
    if (conceptoLower.includes("reparación")) return <BuildIcon />;
    if (
      conceptoLower.includes("mano de obra") ||
      ((conceptoLower.includes("interno") ||
        conceptoLower.includes("interna")) &&
        !conceptoLower.includes("kilometraje"))
    ) {
      return <HandymanIcon />;
    }

    if (conceptoLower.includes("garantia")) return <WorkspacePremiumIcon />;

    if (conceptoLower.includes("cotizacion")) return <RequestPageIcon />;

    if (conceptoLower.includes("mantenimiento")) return <CarRepairIcon />;

    // Valor por defecto
    return <AgricultureIcon />;
  };

  const desviacionServicio = (
    (totalServicio * 100) /
    proyeccionServicio
  ).toFixed(2);
  const desviacionRefacciones = (
    (totalRefacciones * 100) /
    proyeccionRefacciones
  ).toFixed(2);

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  const unidades = Array.from({ length: 8 }, (_, index) => ({
    id: index + 1,
    linea: `Linea ${index + 1}`,
    modelo: `Modelo ${index + 1}`,
    importe: `$${(Math.random() * 1000).toFixed(2)}`, // Genera un importe aleatorio entre 0 y 1000
  }));

  const guiasServicio = [
    { concepto: "venta mano de obra", porcentaje: 35.5 },
    { concepto: "venta de trabajos externos", porcentaje: 7.0 },
    { concepto: "venta de kilometraje", porcentaje: 4.5 },
    { concepto: "garantias jd", porcentaje: 20.5 },
    { concepto: "mano de obra interna", porcentaje: 20.0 },
    { concepto: "tot interna", porcentaje: 4.5 },
    { concepto: "venta de kilometraje interno", porcentaje: 8.0 },
    { concepto: "descuentos de mano de obra", porcentaje: 5.0 },
  ];

  const guiasRefacciones = [
    { concepto: "mostrador", porcentaje: 70.0 },
    { concepto: "taller", porcentaje: 20.0 },
    { concepto: "garantias", porcentaje: 10.0 },
  ];
  const valorminimo = 51; //41
  const valormedio = 85; //85
  const Indicadoresprogreso = ({ valor }) => {
    if (valor < valorminimo) return <TrendingDown />;
    if (valor < valormedio) return <TrendingFlatIcon />;
    return <TrendingUpIcon />;
  };
  const indicadorclase = (valor) => {
    if (valor < valorminimo) return "rojo";
    if (valor < valormedio) return "g-amarillo";
    return "verde";
  };

  const onReporteRefacciones = () => {
    history.push("/PostVenta/ReporteRefacciones");
  };
  const onOTAbiertas = () => {
    history.push("/PostVenta/DashboardOTAbiertas");
  };

  return (
    <PlantillaScreen
      titulo={`DASHBOARD POSVENTA ${info.accesos?.dashboard_titulo.toUpperCase()}`}
      className={"analisis-solicitud-credito"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />
      <div className="facturacion-maquinaria-actions">
        <div
          className="facturacion-maquinaria-actions-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="facturacion-maquinaria-actions-filtro">
          <FiltroDashboardPostventaPersiste
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            ejercicio_inicio={ejercicio_inicio}
            ejercicio_fin={ejercicio_fin}
            periodo_inicio={periodo_inicio}
            periodo_fin={periodo_fin}
            sucursalesEncontrados={sucursales}
            adrEncontrados={adr}
            filtroSucursales={filtroSucursales}
          />
        </div>
        <div className="facturacion-maquinaria-actions-button">
          <button className="ayuda" onClick={() => setOpenHelp(!openHelp)}>
            <HelpOutlineOutlinedIcon /> Ayuda
          </button>

          {openHelp && (
            <div className="popover-help">
              <div className="arrow"></div>

              <div className="popover-titulo">
                <div className="popover-header">
                  <div className="popover-header-titulo">{"Ayuda"}</div>
                </div>
                <div className="plantilla-screen-efecto">
                  <div className="plantilla-screen-efecto-bl"></div>
                  <div className="plantilla-screen-efecto-circle"></div>
                  <div className="plantilla-screen-efecto-br"></div>
                </div>
              </div>

              <p className="texto">
                Los siguientes indicadores están puntuados en base al porcentaje
                mostrado respecto a su guía, quedando las ponderaciones de la
                siguiente manera:
              </p>

              <div className="indicadores">
                <div className="fila">
                  <span className="circulo verde"></span>
                  <span className="label-texto-asd">
                    El porcentaje es mayor o igual a la guía
                  </span>
                </div>

                <div className="fila">
                  <span className="circulo amarillo"></span>
                  <span className="label-texto-asd">
                    El porcentaje esta entre la guía -1%
                  </span>
                </div>

                <div className="fila">
                  <span className="circulo rojo"></span>
                  <span className="label-texto-asd">
                    El porcentaje es menor a la guía -1%
                  </span>
                </div>
              </div>

              <p className="texto">
                En el caso del apartado de Refacciones - Garantias, las
                ponderaciones serian las siguiente:
              </p>

              <div className="indicadores">
                <div className="fila">
                  <span className="circulo verde"></span>
                  <span className="label-texto-asd">
                    Menor o igual a la guía{" "}
                  </span>
                </div>

                <div className="fila">
                  <span className="circulo amarillo"></span>
                  <span className="label-texto-asd">Entre la guía +1%</span>
                </div>

                <div className="fila">
                  <span className="circulo rojo"></span>
                  <span className="label-texto-asd">Mayor a la guía +1%</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="analisis-solicitud-credito-s scroll">
        <div className="section one">
          <div className="dashboard-postventa-servicio-header-main-container">
            <div className="dashboard-postventa-servicio-titulo-main-container">
              <div className="dashboard-postventa-servicio-titulo-texto">
                Servicio
              </div>
            </div>
            <div className="dashboard-postventa-servicio-proyeccion-main-container">
              <div className="dashboard-postventa-servicio-proyeccion-dinero">
                <div className="dashboard-postventa-servicio-proyeccion-dinero-texto">
                  Proyeccion:
                </div>
                <div className="dashboard-postventa-servicio-proyeccion-dinero-monto">
                  $ {FormatMoney(proyeccionServicio, 2)}
                </div>
              </div>
              <div className="dashboard-postventa-servicio-proyeccion-porcentaje">
                <div className="dashboard-postventa-servicio-proyeccion-porcentaje-separador">
                  |
                </div>
                <div
                  className={`dashboard-postventa-servicio-proyeccion-porcentaje-resultado `}
                >
                  {margenServicio}%
                </div>
              </div>
              <div className="dashboard-postventa-servicio-proyeccion-porcentaje">
                <div className="dashboard-postventa-servicio-proyeccion-porcentaje-separador">
                  |
                </div>
                <div
                  className={`dashboard-postventa-servicio-proyeccion-porcentaje-resultado `}
                >
                  {desviacionServicio}%
                  <span className={`${indicadorclase(desviacionServicio)}`}>
                    <Indicadoresprogreso valor={desviacionServicio} />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-postventa-tabla-servicio-container ">
            <div className="dashboard-postventa-servicio-info-conatiner-completo scroll">
              {info.servicio && info.servicio.length > 0 ? (
                <table cellPadding={0} cellSpacing={0}>
                  <tbody>
                    <tr className="tr-encabezado">
                      <td className="reporte-refacciones-button">
                        {info.accesos.mostrar_dash_servicio === true && (
                          <VisibilityIcon onClick={() => onOTAbiertas()} />
                        )}
                    
                      </td>
                      <td>Total Servicio</td>
                      <td className="ta-right">
                        {FormatMoney(totalServicio, 2)}
                      </td>
                      <td>{FormatMoney(costoServicio, 2)} %</td>
                      <td className="ta-right porc-representa"> 100 %</td>
                      <td></td>
                      <td className="guia">GUIA</td>
                    </tr>
                    <tr>
                      <td className="espacio-row" colSpan={8}></td>
                    </tr>
                    {info.servicio
                      .filter(
                        (item) =>
                          item.concepto.toLowerCase() !== "total servicio",
                      )
                      .map((item, index) => {
                        const concepto = item.concepto.toLowerCase();
                        const guia = guiasServicio.find(
                          (g) => g.concepto === concepto,
                        );
                        const guiaPorcentaje = guia ? guia.porcentaje : 0;

                        const diferencia = Math.abs(
                          item.porcentaje - guiaPorcentaje,
                        );

                        let clase = "amarillo";
                        let Icono = HorizontalRuleIcon;

                        if (diferencia >= 1) {
                          if (item.porcentaje < guiaPorcentaje) {
                            clase = "rojo";
                            Icono = TrendingDown;
                          } else {
                            clase = "verde";
                            Icono = TrendingUpIcon;
                          }
                        }

                        return (
                          <tr key={index}>
                            <td className="row-icon">{renderIcon("hola")}</td>
                            <td className="row-concepto">{item.concepto}</td>
                            <td className="row-total formato-moneda">
                              {FormatMoney(item.total, 2)}
                            </td>
                            <td className="row-margen">
                              {FormatMoney(item?.margen, 2)} %
                            </td>
                            <td className="row-porcentaje ta-right">
                              {FormatMoney(item.porcentaje, 2)} %
                            </td>
                            <td className={`row-indicador ${clase}`}>
                              <span
                                className={`indicador-circulo ${clase}`}
                              ></span>
                            </td>
                            <td className="row-guia ta-right">
                              {FormatMoney(guiaPorcentaje, 2)} %
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <div>No hay información disponible.</div>
              )}
            </div>
          </div>
        </div>
        <div className="section two">
          <div className="dashboard-postventa-refacciones-header-main-container">
            <div className="dashboard-postventa-refacciones-titulo-main-container">
              <div className="dashboard-postventa-refacciones-titulo-texto">
                Refacciones
              </div>
            </div>
            <div className="dashboard-postventa-refacciones-proyeccion-main-container">
              <div className="dashboard-postventa-refacciones-proyeccion-dinero">
                <div className="dashboard-postventa-refacciones-proyeccion-dinero-texto">
                  Proyeccion:
                </div>
                <div className="dashboard-postventa-refacciones-proyeccion-dinero-monto">
                  $ {FormatMoney(proyeccionRefacciones, 2)}
                </div>
              </div>
              <div className="dashboard-postventa-refacciones-proyeccion-porcentaje">
                <div className="dashboard-postventa-refacciones-proyeccion-porcentaje-separador">
                  |
                </div>
                <div
                  className={`dashboard-postventa-refacciones-proyeccion-porcentaje-resultado`}
                >
                  {margenRefacciones}%
                </div>
              </div>
              <div className="dashboard-postventa-refacciones-proyeccion-porcentaje">
                <div className="dashboard-postventa-refacciones-proyeccion-porcentaje-separador">
                  |
                </div>
                <div
                  className={`dashboard-postventa-refacciones-proyeccion-porcentaje-resultado`}
                >
                  {desviacionRefacciones}%
                  <span className={`${indicadorclase(desviacionRefacciones)}`}>
                    <Indicadoresprogreso valor={desviacionRefacciones} />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-postventa-tabla-refacciones-container">
            <div className="dashboard-postventa-refacciones-info-tabla-container scroll">
              {info.refacciones && info.refacciones.length > 0 ? (
                <table cellPadding={0} cellSpacing={0}>
                  <tbody>
                    <tr className="tr-encabezado">
                      <td className="reporte-refacciones-button">
                        {info.accesos.mostrar_dash_refacciones === true && (
                          <VisibilityIcon
                            onClick={() => onReporteRefacciones()}
                          />
                        )}
                      </td>
                      <td>Total Refacciones</td>
                      <td className="ta-right">
                        {FormatMoney(totalRefacciones, 2)}
                      </td>
                      <td className="ta-center">
                        {FormatMoney(costoRefacciones, 2)} %
                      </td>
                      <td className="ta-right porc-representa"> 100 %</td>
                      <td></td>
                      <td className="guia">GUIA</td>
                    </tr>
                    <tr>
                      <td className="espacio-row" colSpan={8}></td>
                    </tr>
                    {info.refacciones
                      .filter(
                        (item) =>
                          item.concepto.toLowerCase() !== "total refacciones",
                      )
                      .map((item, index) => {
                        const concepto = item.concepto.toLowerCase();
                        const guia = guiasRefacciones.find(
                          (g) => g.concepto === concepto,
                        );
                        const guiaPorcentaje = guia ? guia.porcentaje : 0;

                        const diferencia = Math.abs(
                          item.porcentaje - guiaPorcentaje,
                        );

                        let clase = "amarillo";
                        let Icono = HorizontalRuleIcon;

                        if (diferencia >= 2) {
                          if (item.porcentaje < guiaPorcentaje) {
                            clase = "rojo";
                            Icono = TrendingDown;
                          } else {
                            clase = "verde";
                            Icono = TrendingUpIcon;
                          }
                        }

                        return (
                          <tr key={index}>
                            <td className="row-icon">
                              {renderIcon("mano de obra")}
                            </td>
                            <td className="row-concepto">{item.concepto}</td>
                            <td className="row-total formato-moneda">
                              {FormatMoney(item.total, 2)}
                            </td>
                            <td className="row-total ta-center">
                              {FormatMoney(item.margen, 2)} %
                            </td>
                            <td className="row-porcentaje ta-right">
                              {FormatMoney(item.porcentaje, 2)} %
                            </td>
                            <td className={`row-indicador ${clase}`}>
                              <span
                                className={`indicador-circulo ${clase}`}
                              ></span>
                            </td>
                            <td className="row-guia ta-center">
                              {FormatMoney(guiaPorcentaje, 2)} %
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <div>No hay información disponible.</div>
              )}
            </div>
            <div
              className="dashboard-postventa-cotizaciones-info-tabla-container"
              // onClick={() => onCotizaciones()}
            >
              <CotizacionesDashPosventa
                data={cotizaciones}
                filtroFecha={filtroFecha}
                filtroSucursales={boxstate.pv}
              />
            </div>
          </div>
        </div>
        {/* <div className="section three">
          <div className="dashboard-postventa-tabla-garantia-container">
            <div className="chart-titulo">Garantias</div>
            <div className="grafica-container">
              <GarantiasChart datos={dataVencimientos} filtroFecha={filtroFecha} filtroSucursales={boxstate.pv} />
            </div>
          </div>
        </div> */}

        <div className="section three">
          <GarantiasPanelDashboard
            sucursales={GetKey(boxstate.pv.sucursal, ["idsucursal"])}
            adr={GetKey(boxstate.pv.adr, ["idadr"])}
            ejercicio_inicio={filtroFecha.ejercicio_inicio}
            ejercicio_fin={filtroFecha.ejercicio_fin}
            periodo_inicio={filtroFecha.periodo_inicio}
            periodo_fin={filtroFecha.periodo_fin}
            filtroSucursales={boxstate.pv}
            garantias={garantiasTempranas}
            encabezado={"Powergard Venta Temprana"}
          />

          <GarantiasPanelDashboard
            sucursales={GetKey(boxstate.pv.sucursal, ["idsucursal"])}
            adr={GetKey(boxstate.pv.adr, ["idadr"])}
            ejercicio_inicio={filtroFecha.ejercicio_inicio}
            ejercicio_fin={filtroFecha.ejercicio_fin}
            periodo_inicio={filtroFecha.periodo_inicio}
            periodo_fin={filtroFecha.periodo_fin}
            filtroSucursales={boxstate.pv}
            garantias={garantiasTardias}
            encabezado={"Powergard Venta Tardía"}
          />
        </div>

        <div className="section four">
          <GarantiasPanelDashboard
            sucursales={GetKey(boxstate.pv.sucursal, ["idsucursal"])}
            adr={GetKey(boxstate.pv.adr, ["idadr"])}
            ejercicio_inicio={filtroFecha.ejercicio_inicio}
            ejercicio_fin={filtroFecha.ejercicio_fin}
            periodo_inicio={filtroFecha.periodo_inicio}
            periodo_fin={filtroFecha.periodo_fin}
            filtroSucursales={boxstate.pv}
            garantias={garantiasChecklist}
            encabezado={"Checklist"}
          />

          <MantenimientoPanelDashboard
            sucursales={GetKey(boxstate.pv.sucursal, ["idsucursal"])}
            adr={GetKey(boxstate.pv.adr, ["idadr"])}
            ejercicio_inicio={filtroFecha.ejercicio_inicio}
            ejercicio_fin={filtroFecha.ejercicio_fin}
            periodo_inicio={filtroFecha.periodo_inicio}
            periodo_fin={filtroFecha.periodo_fin}
            filtroSucursales={boxstate.pv}
            serviciosPendientes={serviciosPendientes}
          />
        </div>
      </div>
      <MensajeGarantiaModal
        open={openModal}
        onClose={handleCloseModal}
        tipoGarantia={selectedTipoGarantia}
      />
    </PlantillaScreen>
  );
};
